var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeaktivirajRacun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 28,
    height: 28,
    fill: "#e63036"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303",
    transform: "translate(-203 -558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1304",
    "data-name": "Group 1304",
    transform: "translate(203 558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1303-2",
    "data-name": "Group 1303",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M14,2A12,12,0,1,1,2,14,12.035,12.035,0,0,1,14,2m0-2A14,14,0,1,0,28,14,14.041,14.041,0,0,0,14,0",
    fill: "#e63036"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 16,
    height: 2,
    transform: "translate(6 13)",
    fill: "#e63036"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeaktivirajRacun);
export default __webpack_public_path__ + "static/media/deaktiviraj_racun.bcfde5bd5fb2841559265697f8d444b2.svg";
export { ForwardRef as ReactComponent };